import React from 'react';

// Types
type NodeActionType = 'OPEN_NODE';
type NodeAction = { type: NodeActionType; payload?: boolean | string };

type NodeDispatch = (action: NodeAction) => void;

interface NodeState {
  openNode: string;
}

const NodeStateContext = React.createContext<NodeState | undefined>(undefined);
const NodeDispatchContext = React.createContext<NodeDispatch | undefined>(undefined);

const initialState: NodeState = {
  openNode: '',
};

const sidebarReducer = (state: NodeState, action: NodeAction) => {
  switch (action.type) {
    case 'OPEN_NODE':
      return { ...state, openNode: action.payload as string };
    default:
      return state;
  }
};

export const NodeProvider: React.FC = ({ children }: any) => {
  const [state, dispatch] = React.useReducer(sidebarReducer, initialState);

  return (
    <NodeStateContext.Provider value={state}>
      <NodeDispatchContext.Provider value={dispatch}>{children}</NodeDispatchContext.Provider>
    </NodeStateContext.Provider>
  );
};

export const useNodeState = () => {
  const context = React.useContext(NodeStateContext);
  if (context === undefined) {
    throw new Error('useNodeState must be used within a NodeProvider');
  }
  return context;
};

export const useNodeDispatch = () => {
  const context = React.useContext(NodeDispatchContext);
  if (context === undefined) {
    throw new Error('useNodeDispatch must be used within a NodeProvider');
  }
  return context;
};
